import * as models from './models';

export function CanAmount(paymentOptionTypeID?: models.PaymentOptionTypeID) {
    return paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BALANCE ||
        paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_CREDIT ||
        paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_BANK;
}